import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { notifierSlice, showNotification as showAction } from "../slice";
import { NotificationData } from "../types";

export function useNotifierApi() {
  const dispatch = useDispatch();

  const showNotification = useCallback(
    (notification: Omit<NotificationData, "uuid" | "createdAt">) => {
      dispatch(showAction(notification));
    },
    [dispatch],
  );

  const removeNotification = useCallback(
    (uuid: string) => {
      dispatch(notifierSlice.actions.remove(uuid));
    },
    [dispatch],
  );

  return [showNotification, removeNotification] as const;
}
